import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import {
  get,
  has,
  isEmpty,
  map,
} from 'lodash';
import styles from './ArticleHero.module.styl';
import sizeImage from '../../lib/sizeImage';

// The reducer will automatically receive the first string as the initial value, then start from
// the second.
const buildNameList = (names) => names.reduce(
  (accumulator, currentValue, index, array) => {
    if (index < array.length - 1) {
      return `${accumulator}, ${currentValue}`;
    }
    return `${accumulator} and ${currentValue}`;
  },
);

const ArticleHero = ({ story, site }) => {
  const bylineNames = map(get(story, 'credits.by', []), 'name')
    .filter((name) => !isEmpty(name.trim()));
  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <p className={classNames(styles.overline, 'bentoncond-n4')}>
          <Link to="/" className={styles.indexLink}>
            {`${site.siteMetadata.title}`}
          </Link>
        </p>
        <h1 className={classNames(styles.headline, 'millerbanner-n4')}>
          {story.headlines.basic}
        </h1>
        <h2 className={classNames(styles.subhead, 'miller-n4')}>
          {get(story, 'subheadlines.basic', '')}
        </h2>
        {(bylineNames.length > 0) && (
          <address className={styles.byline}>
            <p className="bentoncond-n4">
              {`By ${buildNameList(bylineNames)}`}
            </p>
          </address>
        )}
      </div>
      {
        has(story, 'promo_items.basic.url')
        && story.promo_items.basic.url.trim() !== ''
        && (
          <figure className={styles.figure}>
            <img
              src={sizeImage({ width: 1200, src: story.promo_items.basic.url })}
              alt={get(story, 'promo_items.basic.caption', '')}
            />
            <cite className="bentoncond-n4">
              <span>
                {get(story, 'promo_items.basic.credits.by[0].name')}
              </span>
            </cite>
          </figure>
        )
      }
    </section>
  );
};

ArticleHero.propTypes = {
  story: PropTypes.shape({
    storyId: PropTypes.string.isRequired,
    headlines: PropTypes.objectOf(PropTypes.string).isRequired,
    subheadlines: PropTypes.objectOf(PropTypes.string).isRequired,
    credits: PropTypes.shape({
      by: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        affiliation: PropTypes.string,
      })).isRequired,
    }),
    promo_items: PropTypes.shape({
      basic: PropTypes.shape({
        url: PropTypes.string.isRequired,
        credits: PropTypes.shape({
          by: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            affiliation: PropTypes.string,
          })).isRequired,
        }),
        caption: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    content_elements: PropTypes.array.isRequired,
  }).isRequired,
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ArticleHero;
